// extracted by mini-css-extract-plugin
export var statItem = "_iu-1";
export var statsRow = "_iu-0";